// Definición de defaults

export const defaultTipoResolucion: TipoResolucionProps = {
    idTipoResolucion:   0,
    descripcion:        '',
    activo:             false,
};

// Creación de interfaces

export interface TipoResolucionProps   {
    idTipoResolucion:   number;
    descripcion:        string;
    activo:             boolean;
}